import { useState } from "react";
import { Propiedad, EstadoPropiedad } from "../../types";

interface CambiarEstadoPropiedadModalProps {
  propiedad: Propiedad;
  onSubmit: (propiedad: Propiedad) => void;
  onCancel: () => void;
}

export function CambiarEstadoPropiedadModal({
  propiedad,
  onSubmit,
  onCancel,
}: CambiarEstadoPropiedadModalProps) {
  const [estado, setEstado] = useState<EstadoPropiedad>(propiedad.estadoPropiedad);
  const [motivo, setMotivo] = useState(propiedad.motivoEstado || "");

  const handleSubmit = (e: React.FormEvent) => {
    e.preventDefault();
    if (estado !== "activa" && !motivo.trim()) return;

    onSubmit({
      ...propiedad,
      estadoPropiedad: estado,
      motivoEstado: estado !== "activa" ? motivo.trim() : undefined,
      fechaCambioEstado: estado !== "activa" ? new Date().toISOString().split("T")[0] : undefined,
    });
  };

  const isValid = estado === "activa" || motivo.trim().length > 0;

  return (
    <form onSubmit={handleSubmit} className="space-y-4">
      <div>
        <p className="text-sm text-slate-600 mb-3">
          ROL <span className="font-semibold">{propiedad.rol}</span> - {propiedad.comuna}
        </p>
      </div>

      <div>
        <label className="block text-sm font-medium text-slate-700 mb-1">
          Estado
        </label>
        <select
          value={estado}
          onChange={(e) => setEstado(e.target.value as EstadoPropiedad)}
          className="w-full px-3 py-2 border border-slate-200 rounded-lg text-sm focus:outline-none focus:ring-2 focus:ring-blue-500"
        >
          <option value="activa">Activa</option>
          <option value="desvinculada">Desvinculada</option>
          <option value="bloqueada">Bloqueada</option>
        </select>
      </div>

      {estado !== "activa" && (
        <div>
          <label className="block text-sm font-medium text-slate-700 mb-1">
            Motivo *
          </label>
          <textarea
            value={motivo}
            onChange={(e) => setMotivo(e.target.value)}
            placeholder={estado === "desvinculada" ? "Razon de desvinculacion..." : "Razon de bloqueo..."}
            rows={3}
            className="w-full px-3 py-2 border border-slate-200 rounded-lg text-sm focus:outline-none focus:ring-2 focus:ring-blue-500"
          />
        </div>
      )}

      <div className="flex justify-end gap-3 pt-4 border-t border-slate-200">
        <button
          type="button"
          onClick={onCancel}
          className="px-4 py-2 text-sm font-medium text-slate-700 bg-slate-100 hover:bg-slate-200 rounded-lg transition-colors"
        >
          Cancelar
        </button>
        <button
          type="submit"
          disabled={!isValid}
          className="px-4 py-2 text-sm font-medium text-white bg-blue-600 hover:bg-blue-700 rounded-lg transition-colors disabled:bg-slate-300 disabled:cursor-not-allowed"
        >
          Guardar
        </button>
      </div>
    </form>
  );
}
